<div class="row login-select" *ngIf="!capitalLogin && !bridgePlusLogin">
  <div class="col-6 login-background">
    <img src="../../assets/images/login-background.png">
  </div>
  <div class="col-1"></div>
  <div class="col-5 login-content">
    <div class="right-content">
      <div class="row">
        <div class="col-12">
          <p>Login to</p>
        </div>
      </div>

      <div *ngIf="tokens.length > 1">
        <div class="row">
          <div class="col-12">
            <input type="radio" id="bridge-plus" name="login-type" value="bridgePlus" style="display: none;"
              (change)="select($event.target.value)">
            <label for="bridge-plus">
              <div class="row mt-2" [ngClass]="(!showBridgePlus)?'block':'selected-block'">
                <img src="../../assets/images/bridgeplus-logo.png">
                <p>You are part of our coworking community & enjoy our exclusive member only ammenities.</p>
              </div>
            </label>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <input type="radio" id="capital-land" name="login-type" value="capitalLand" style="display: none;"
              (change)="select($event.target.value)">
            <label for="capital-land">
              <div class="row  mt-3" [ngClass]="(!showCapitalLand)?'block':'selected-block'">
                <img src="../../assets/images/capitaland.png">
                <p>You are part of our world class IT parks & enjoy the exemplary views & park facilities.</p>
              </div>
            </label>
          </div>
        </div>
      </div>

      <div *ngIf="tokens.length == 1">
        <div *ngIf="tokens[0].userType == 'Bridge+'">
          <div class="row">
            <div class="col-12">
              <input type="radio" id="bridge-plus" name="login-type" value="bridgePlus" style="display: none;"
                (change)="select($event.target.value)">
              <label for="bridge-plus">
                <div class="row mt-2" [ngClass]="(!showBridgePlus)?'block':'selected-block'">
                  <img src="../../assets/images/bridgeplus-logo.png">
                  <p>You are part of our coworking community & enjoy our exclusive member only ammenities.</p>
                </div>
              </label>
            </div>
          </div>
        </div>

        <div *ngIf="tokens[0].userType == 'Parkite'">
          <div class="row">
            <div class="col-12">
              <input type="radio" id="capital-land" name="login-type" value="capitalLand" style="display: none;"
                (change)="select($event.target.value)">
              <label for="capital-land">
                <div class="row  mt-3" [ngClass]="(!showCapitalLand)?'block':'selected-block'">
                  <img src="../../assets/images/capitaland.png">
                  <p>You are part of our world class IT parks & enjoy the exemplary views & park facilities.</p>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-8"></div>
        <div class="col-4">
          <button type="submit" class="mt-3" (click)="submit()" [disabled]="loginType==''">Continue<span
              class="ml-3">></span></button>
        </div>
      </div>
    </div>

  </div>
</div>

<div *ngIf="isLoaded==true&&capitalLogin">
  <div class="col-12 p-0 m-0 row d-flex justify-content-between">
    <div class="col-4-image col-5 col-4-color">
      <div class="text-center mt-4">
        <span class="start-building">
          Start building
        </span>
        <span class="community">
          <br>
          our community
        </span>
        <span class="manage-organisations">
          <br>
          Manage organisations & their members
        </span>
      </div>


      <!-- <img src="assets/images/login-cla-image.png" class="" alt="smaple image"> -->
    </div>
    <div class="col-7 p-0 d-flex justify-content-center">
      <div class="mt-5">
        <span><img src="assets/images/capitaland-cla-logo.png" class="" alt="smaple image"></span>
        <span class="row">
          <label class="login login-margin pt-3 pl-2 login">Login</label>

        </span>
        <div class="pt-3 login-margin">
          <div class="form-group iLife-form-group mb-4">
            <label for="mobile-emailid" class="form-label">Email ID</label>
            <input class="form-control form-control-lg" id="mobile-emailid" [(ngModel)]="emailId" type="text"
              placeholder="">

          </div>
          <div class="pt-3">
            <button type="submit" class="btn submit-btn login-btn d-block mx-auto btn-lg add-button add"
              (click)="submitLogin()">Login</button>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="bridgePlusLogin">
  <div>
    <div class="view">
      <div class="rectangle-pos">
        <div class="rectangle p-5">
          <div class="row d-flex logo-justify ">
            <img class="logo-height" src="/assets/images/bridgeplus-logo.png" loading="lazy" />

            <img class="" src="/assets/images/capitaland.png" loading="lazy" />

          </div>
          <div *ngIf="showLogin">
            <label class="login login-margin pt-2">Login</label>
            <div class="pt-3 login-margin">
              <form [formGroup]="loginPassForm">
                <div class="form-group iLife-form-group mb-4">
                  <label for="mobile-emailid" class="form-label"
                    [ngClass]="{'label-invalid':showErrorLoginpass && loginPassForm.controls.mobileEmailId.status== 'INVALID'}">Email
                    ID</label>
                  <input class="form-control form-control-lg"
                    [ngClass]="{'form-invalid':showErrorLoginpass && loginPassForm.controls.mobileEmailId.status== 'INVALID'}"
                    id="mobile-emailid" [(ngModel)]="emailId" type="text" placeholder="" formControlName="mobileEmailId"
                    email (keyup)="validateEmail()" maxlength="50" style="width: 100%;" />
                  <span *ngIf="invalidEmail && !showErrorLoginpass" class="error-text">Please enter
                    a valid email id</span>
                  <span *ngIf="!isvalidBridgePlusEmail && !showErrorLoginpass" class="error-text">
                    Couldn't find your Bridge+ account</span>
                  <span *ngIf="isLoginAttemptsFailure" class="error-text">
                    Due to consecutive wrong attempt, your account has been locked for sometime. Please try in a
                    while.</span>
                </div>
                <div>
                  <div class="form-group iLife-form-group mb-3">
                    <label for="pass" class="form-label"
                      [ngClass]="{'label-invalid':showErrorLoginpass && loginPassForm.controls.password.status== 'INVALID'}">Password</label>
                    <input class="form-control form-control-lg pwd-input"
                      [ngClass]="{'form-invalid':showErrorLoginpass && loginPassForm.controls.password.status== 'INVALID'}"
                      id="pass" [type]="show ? 'text' : 'password'" [(ngModel)]="password" placeholder=""
                      formControlName="password" minlength="8" style="width: 100%;">
                    <img (click)="togglePassword()"
                      [src]="show?'assets/images/show-password.png':'assets/images/hide-password.png'"
                      class="form-append-img cursor-default" loading="lazy" />
                  </div>
                  <div>
                    <span *ngIf="passwordError && loginPassForm.controls.password.status== 'INVALID'"
                      class="error-text before-login-error">Enter password before clicks on login.</span>

                    <div *ngIf="passwordMinLengthError && loginPassForm.controls.password.status== 'INVALID'"
                      class="error-text">Passwords must be no less than 8 characters in length.</div>
                  </div>
                </div>
                <!-- <div class="custom-control custom-switch" style="float:left;">
                          <input type="checkbox" class="custom-control-input" id="customSwitches" >
                          <label class="custom-control-label" for="customSwitches">CLA</label>
                        </div> -->

                <div class="row justify-content-end no-gutters" *ngIf="enableForgotPwdLink">
                  <span class="btn link-btn float-right p-0 forgot-password" (click)="forgotPassword()">Forgot
                    Password?</span>
                </div>
                <div class="pt-3">
                  <button type="submit" [ngClass]="{'disable-button':!loginPassForm.valid}"
                    class="btn submit-btn login-btn d-block mx-auto btn-lg" (click)="submitLogin()">Login</button>

                </div>

              </form>
            </div>
          </div>
          <!-- <div *ngIf="showForgotPassword">
              <label class="login login-margin pt-2">Account recovery
              </label>
              <label class="sub-text login-margin pt-2">Don’t worry! We will email you reset password link to the
                following
                ID
              </label>
              <div class="pt-3 login-margin">
                <form [formGroup]="forgotPasswordForm">
                  <div class="form-group iLife-form-group mb-4">
                    <label for="mobile-emailid" class="form-label"
                      [ngClass]="{'label-invalid':showErrorLoginpass && loginPassForm.controls.mobileEmailId.status== 'INVALID'}">
                      Email ID</label>
                    <input class="form-control form-control-lg"
                      [ngClass]="{'form-invalid':showErrorLoginpass && loginPassForm.controls.mobileEmailId.status== 'INVALID'}"
                      maxlength="50" id="mobile-emailid" [(ngModel)]="emailId" type="text" placeholder=""
                      formControlName="mobileEmailId" (keyup)="validateEmail()">
                    <span *ngIf="invalidEmail && !showErrorLoginpass" class="error-text">Please enter
                      a valid email id</span>
                    <span *ngIf="!isvalidBridgePlusEmail && !showErrorLoginpass" class="error-text">
                      Couldn't find your Bridge+ account</span>
  
                  </div>
                  <div class="pt-3 reset-pos">
                    <button type="submit" [ngClass]="{'disable-button':!forgotPasswordForm.valid}"
                      class="btn reset-btn  submit-btn d-block  btn-lg" (click)="submitResetInstruction()">Send Reset
                      Instruction</button>
  
                  </div>
  
                </form>
              </div>
            </div> -->


          <div *ngIf="showEmailSent">
            <label class="login login-margin pt-2">Email sent
            </label>
            <!-- <label class="email-sub-text login-margin pt-2">We sent a message to <b>{{emailId}}</b> so you
                can pick your new password.
              </label> -->
            <label class="email-sub-text login-margin pt-2">{{emailSentText}}
            </label>
            <label class="email-sub-text login-margin">Didn't get the email? Please try again</label>
            <div class="pt-3 login-margin email-sent-pos">
              <button type="submit" [ngClass]="{'disable-button':!forgotPasswordForm.valid}"
                class="cancel-button cancel pr-4" (click)="tryAgain()" *ngIf="enableForgotPwdLink">Try Again</button>
              <button type="submit" [ngClass]="{'disable-button':!forgotPasswordForm.valid}"
                class="btn reset-btn  submit-btn d-block  btn-lg" (click)="backtoLogin()">Back To Login</button>
            </div>
          </div>


          <div *ngIf="showSetPassword">
            <label class="login login-margin pt-2">Set new password</label>
            <div class="pt-3 login-margin">
              <form [formGroup]="setPassForm">
                <div class="form-group iLife-form-group mb-2">
                  <label for="newpassword" class="form-label"
                    [ngClass]="{'label-invalid': invalidPWD && setPassForm.controls.newpassword.status == 'INVALID'}">new
                    password</label>
                  <input [type]="showPassword ? 'text' : 'password'" class="form-control form-control-lg"
                    id="newpassword" name="newpassword" formControlName="newpassword" [(ngModel)]="newpassword"
                    (blur)="validatedPwdRegex(1)" minlength="8" required
                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                    [ngClass]="{'form-invalid':invalidPWD && setPassForm.controls.newpassword.status == 'INVALID'}">

                  <img (click)="toggleResetPassword()"
                    [src]="showPassword?'assets/images/show-password.png':'assets/images/hide-password.png'"
                    class="form-append-img cursor-default" loading="lazy" />
                  <!-- <input class="form-control form-control-lg" [ngClass]="{'form-invalid':setPassForm.controls.newpassword.status== 'INVALID'}" id="mobile-emailid"
                           [(ngModel)]="newPassword" type="text" placeholder="" formControlName="newpassword">
                          <img src="assets/images/show-password.png" class="form-append-img cursor-default"> -->
                </div>
                <div>
                  <span *ngIf="invalidPWD" class="error-text">Please enter password</span>
                  <span class="error-text"
                    *ngIf="setPassForm.controls.newpassword.status == 'INVALID' && passOneErr">Password must be
                    minimum
                    8
                    characters and should
                    contain atleast 1
                    uppercase, 1 lowercase, a number and a special character</span>
                </div>

                <span *ngIf="newPasswordMinLengthError && loginPassForm.controls.password.status== 'INVALID'"
                  class="error-text">Passwords must be no less than 8 characters in length.</span>
                <div class="row d-flex justify-content-between" *ngIf="newpassword.length>0">
                  <div>
                    <span class="password-strenght" style="
                              margin-left: 19px;
                          ">Password Strength</span>
                    <img class="" src="assets/images/password-strength.png" loading="lazy">
                  </div>

                  <div>
                    <app-password-strength-bar [passwordToCheck]="newpassword" [barLabel]="barLabel">
                    </app-password-strength-bar>
                  </div>

                  <!-- <password-strength-meter [password]="newPassword"></password-strength-meter> -->
                </div>
                <div class="form-group iLife-form-group mb-3 mt-4">
                  <label for="newpasswordconfirm" class="form-label"
                    [ngClass]="{'label-invalid': invalidConfirmPWD && setPassForm.controls.newpasswordconfirm.status== 'INVALID'}">Confirm
                    Password</label>
                  <input class="form-control form-control-lg" id="newpasswordconfirm" name="newpasswordconfirm"
                    [type]="showConfirmPassword ? 'text' : 'password'" [(ngModel)]="newpasswordconfirm" minlength="8"
                    required formControlName="newpasswordconfirm" (blur)="validatedPwdRegex(2)"
                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                    [ngClass]="{'form-invalid':invalidConfirmPWD && setPassForm.controls.newpasswordconfirm.status== 'INVALID'}">
                  <!-- <span *ngIf="setPassForm.controls.password.status== 'INVALID'" class="error-text">The password you entered is incorrect</span> -->
                  <img (click)="toggleConfirmPassword()"
                    [src]="showConfirmPassword?'assets/images/show-password.png':'assets/images/hide-password.png'"
                    class="form-append-img cursor-default" loading="lazy" />
                </div>
                <div>
                  <span *ngIf="invalidConfirmPWD" class="error-text">Please enter confirm password</span>
                  <span class="error-text"
                    *ngIf="setPassForm.controls.newpasswordconfirm.status == 'INVALID' && passTwoErr">Password must be
                    minimum
                    8
                    characters and should
                    contain atleast 1
                    uppercase, 1 lowercase, a number and a special character</span>
                </div>
                <div>
                  <span *ngIf="invalidPasswordMatch" class="error-text">Your password and confirmation password do not
                    match</span>
                </div>
                <div *ngIf="newConfirmPasswordMinLengthError && loginPassForm.controls.password.status== 'INVALID'"
                  class="error-text">Passwords must be no less than 8 characters in length.</div>
                <div class="pt-5 d-flex justify-content-end">
                  <button type="submit" [ngClass]="{'disable-button':!setPassForm.valid}"
                    [disabled]="!setPassForm.valid"
                    class="btn submit-btn login-btn d-block btn reset-btn  submit-btn d-block  btn-lg btn-lg"
                    (click)="confirm()">Confirm</button>

                </div>

              </form>
            </div>
          </div>
          <div *ngIf="showDeactivated">
            <label class="login login-margin pt-2">Account deactivated
            </label>
            <label class="email-sub-text login-margin pt-2">Your <b>{{this.emailId}}</b> Bridge+ account is
              deactivated.
            </label>
            <div class="pt-5 login-margin email-sent-pos">
              <button type="submit" [ngClass]="{'disable-button':!forgotPasswordForm.valid}"
                class="btn reset-btn  submit-btn d-block  btn-lg" (click)="backtoLogin()">Back To Login</button>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

</div>
<!-- <div class="">
      <div class="d-flex justify-content-end footer-position" >
          <div class="justify-content-end copyright pr-5 pt-4">
              copyright c 2010-11 . All rights reserved
          </div>
          </div>
  </div> -->